import { render, staticRenderFns } from "./TabbedFeedback.vue?vue&type=template&id=548b080b"
import script from "./TabbedFeedback.vue?vue&type=script&lang=js"
export * from "./TabbedFeedback.vue?vue&type=script&lang=js"
import style0 from "./TabbedFeedback.vue?vue&type=style&index=0&id=548b080b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports